module.exports = __webpack_public_path__ + "static/media/survey-background.c2e36a2d.png";